module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div><div id="'+
((__t=( switchId))==null?'':__t)+
'"><div v-if="\'disabled\' !== zoneMode"><a href="#" @click="onClickOpenZone($event)" id="open'+
((__t=( cid))==null?'':__t)+
'"><label for="'+
((__t=( switchId))==null?'':__t)+
'">'+
((__t=( name ))==null?'':__t)+
'</label></a><div class="input"><defa-radio-strip v-model="onOffValue" :options="options" v-bind:disabled="locked" v-bind:class="{ errorState: disableZoneSwitch }" v-on:input="save($event, \'onOff\')"></defa-radio-strip><p v-show="modelError" class="error">ERROR! {{ modelError }}</p><p v-show="attributeError" class="error">{{ attributeError }}</p></div></div><div v-if="\'disabled\' === zoneMode"><a href="#" @click="onClickOpenZone($event)" id="open'+
((__t=( cid))==null?'':__t)+
'"><dl><dt>'+
((__t=( name ))==null?'':__t)+
'</dt><dd>'+
((__t=( i18n.tc("ZoneViewSimple", "Mode: OFF") ))==null?'':__t)+
'</dd></dl></a></div></div></div>';
}
return __p;
};
